@if (showBanner && isLoggedIn) {
    <ws-ace-banner
        class="d-block top-banner"
        [block]="true"
        [enableDismiss]="true"
        [content]="bannerMessage?.message"
        (dismissed)="dismissBanner()"
    >
    </ws-ace-banner>
}
<ace-header
    [logoSrc]="branding.logoUrl"
    [logoTitle]="branding.logoTitle"
    [currentAction]="currentAction || null"
    [actions]="chromeActions"
    [enableNav]="isLoggedIn"
    wsShadowDataQa=".nav-primary ace-button"
    shadowDataQaValue="main-menu-hamburger"
    (headerActivated)="handleActionTriggered($any($event))"
    style="filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.24))"
    (sideNavActivated)="toggleSideNav()"
>
</ace-header>
@if (isLoggedIn && showInstanceFilter) {
    <div class="instance-filter d-flex justify-content-end pe-3">
        <ws-instance-filter></ws-instance-filter>
    </div>
}
@if (isLoggedIn) {
    <snack-bar></snack-bar>
}
